import { render, staticRenderFns } from "./CustomerDependantForm.vue?vue&type=template&id=383f2d62&scoped=true"
import script from "./CustomerDependantForm.vue?vue&type=script&lang=js"
export * from "./CustomerDependantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f2d62",
  null
  
)

export default component.exports